import React from 'react';
import { Link } from 'react-router-dom';
import { ClipboardCheckIcon, FactoryIcon, PackageIcon, FileTextIcon, ShoppingCartIcon, SettingsIcon, CogIcon, ShoppingBagIcon, ArrowRightIcon, FlaskConicalIcon } from 'lucide-react';
function MenuItem({
  icon: Icon,
  label,
  to
}: {
  icon: any;
  label: string;
  to: string;
}) {
  return <Link to={to} className="flex items-center gap-3 group/item" data-id="element-301">
      <div className="p-1.5 rounded-md bg-white/5 group-hover/item:bg-violet-electric/20 transition-colors" data-id="element-302">
        <Icon className="w-4 h-4 text-white/60 group-hover/item:text-violet-electric transition-colors" data-id="element-303" />
      </div>
      <span className="text-white/80 text-sm font-medium group-hover/item:text-white transition-colors" data-id="element-304">
        {label}
      </span>
    </Link>;
}
export function SolutionsMenu({
  onClose
}: {
  onClose?: () => void;
}) {
  return <div className="absolute top-full left-1/2 -translate-x-1/2 w-[900px] pt-3 z-50" onClick={onClose} data-id="element-305">

      <div className="bg-[#0D0B2E]/95 backdrop-blur-xl border border-white/10 rounded-xl shadow-2xl overflow-hidden" data-id="element-306">
        <div className="grid grid-cols-12 divide-x divide-white/10" data-id="element-307">
          {/* Left Column: Intro */}
          <div className="col-span-3 p-6 bg-white/[0.02] flex flex-col justify-between" data-id="element-308">
            <div data-id="element-309">
              <h3 className="text-white font-semibold text-sm tracking-wide mb-3" data-id="element-310">
                All Solutions
              </h3>
              <p className="text-white/60 text-sm leading-relaxed" data-id="element-311">
                Operational modules built to work together. Adaptable to your
                company's workflows.
              </p>
            </div>
          </div>

          {/* Middle Column: Modules */}
          <div className="col-span-5 p-6" data-id="element-312">
            <h3 className="text-white/40 text-[10px] font-bold uppercase tracking-widest mb-4" data-id="element-313">
              By Module
            </h3>
            <div className="grid grid-cols-1 gap-y-3" data-id="element-314">
              <MenuItem icon={ShoppingCartIcon} label="Purchasing" to="/solutions/purchasing" data-id="element-315" />

              <MenuItem icon={PackageIcon} label="Inventory Management" to="/solutions/inventory-management" data-id="element-316" />

              <MenuItem icon={FactoryIcon} label="Production" to="/solutions/manufacturing-mes" data-id="element-317" />

              <MenuItem icon={ClipboardCheckIcon} label="Quality" to="/solutions/quality" data-id="element-318" />

              <MenuItem icon={FileTextIcon} label="Sales and Quoting" to="/solutions/sales-and-quoting" data-id="element-319" />

              <MenuItem icon={SettingsIcon} label="Custom Operating System" to="/solutions/custom" data-id="element-320" />

            </div>
          </div>

          {/* Right Column: Industries */}
          <div className="col-span-4 p-6 bg-white/[0.02]" data-id="element-321">
            <h3 className="text-white/40 text-[10px] font-bold uppercase tracking-widest mb-4" data-id="element-322">
              By Industry
            </h3>
            <div className="grid grid-cols-1 gap-y-3" data-id="element-323">
              <MenuItem icon={FactoryIcon} label="Manufacturing" to="/industries/manufacturing" data-id="element-324" />

              <MenuItem icon={CogIcon} label="Industrial Operations" to="/industries/industrial-operations" data-id="element-325" />

              <MenuItem icon={ShoppingBagIcon} label="Complex Consumer Products" to="/industries/consumer-products" data-id="element-326" />

              <MenuItem icon={FlaskConicalIcon} label="Biotech" to="/industries/biotech" data-id="element-327" />

            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="grid grid-cols-12 divide-x divide-white/10 border-t border-white/10 bg-white/[0.02]" data-id="element-328">
          <div className="col-span-3" data-id="element-329"></div>
          <Link to="/solutions" className="col-span-5 px-6 py-3 flex items-center justify-between group hover:bg-white/[0.04] transition-colors" data-id="element-330">

            <span className="text-white/90 text-xs font-medium" data-id="element-331">
              View all modules
            </span>
            <ArrowRightIcon className="w-3.5 h-3.5 text-white/40 group-hover:text-white group-hover:translate-x-0.5 transition-all" data-id="element-332" />
          </Link>
          <Link to="/solutions#industries" className="col-span-4 px-6 py-3 flex items-center justify-between group hover:bg-white/[0.04] transition-colors" data-id="element-333">

            <span className="text-white/90 text-xs font-medium" data-id="element-334">
              View all industries
            </span>
            <ArrowRightIcon className="w-3.5 h-3.5 text-white/40 group-hover:text-white group-hover:translate-x-0.5 transition-all" data-id="element-335" />
          </Link>
        </div>
      </div>
    </div>;
}